import Cookies from 'js-cookie'

//与IOS或安卓数据交互
function setupWebViewJavascriptBridge(callback) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
       var WKJSBridge= (function () {
            console.log('初始化');

            function WKJSBridge() {
                this.uniqueId = 1;
                this.callbackCache = {};
            }
           /**
            * 调用 Natvie 方法
            * @param service 模块
            * @param action 方法
            * @param actionArgs 数据
            * @param callback 调用回调
            */
           WKJSBridge.prototype.callNative = function (service, action, actionArgs, successCallback, failCallback) {
               var message = {
                   service: service || 'default',
                   action: action,
                   actionArgs: actionArgs,
                   callbackId: null
               };
               if (successCallback || failCallback) {
                   // 拼装 callbackId
                   var callbackId = 'cb_' + message.service + '_' + action + '_' + (this.uniqueId++) + '_' + new Date().getTime();                // 缓存 callback，用于在 Native 处理完消息后，通知 H5
                   this.callbackCache[callbackId] = {success:successCallback, fail:failCallback};
                   // 追加 callbackId 属性
                   message.callbackId = callbackId;
               }
               // 发送消息给 Native
               window.webkit.messageHandlers.WKJSBridgeMessageName.postMessage(JSON.stringify(message));
           };
           /**
            * 用于处理来自 Native 的消息
            * @param callbackMessage 回调消息
            */
           WKJSBridge.prototype._handleMessageFromNative = function (messageString) {
               var callbackMessage = JSON.parse(messageString);
               var status = messageString.status;
               var callback = this.callbackCache[callbackMessage.callbackId];
               if (callback) { // 执行 callback 回调，并删除缓存的 callback
                   if (status == '0') {//失败回调
                       callback.fail(JSON.stringify(callbackMessage.data));
                   }else {//成功回调
                       callback.success(JSON.stringify(callbackMessage.data));
                   }
                   this.callbackCache[callbackMessage.callbackId] = null;
                   delete this.callbackCache[callbackMessage.callbackId];
               }

           };
           return WKJSBridge;
        })()
        window.WKJSBridge = new WKJSBridge()
    }

    if(isiOS){
        return
    }
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
    } else {
        document.addEventListener(
            'WebViewJavascriptBridgeReady'
            , function () {
                callback(window.WebViewJavascriptBridge)
            },
            false
        );
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}


export default {
    bridgeInit() {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.init(function (message, responseCallback) {
                console.log('JS got a message', message);
                var data = {
                    'Javascript Responds': Cookies.get('code')
                };
                if (responseCallback) {
                    console.log('JS responding with', data);
                    responseCallback(data);
                }
            });
        })
    },
    callhandler(name, data, callback) {
        if (typeof data == 'object') {
            data['uuid'] = Cookies.get('uuid')
        }
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
            console.log('ios');
            window.WKJSBridge.callNative('WKCommonPlugin', name, data,function success(data) {
                callback(data)
            } );

        } else {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler(name, data, callback)
            })
        }

    },

    registerhandler(name, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            if (isAndroid) {
                bridge.init(function (message, responseCallback) {
                    console.log('JS got a message', message);
                    var data = {
                        'Javascript Responds': '测试中文!'
                    };
                    if (responseCallback) {
                        console.log('JS responding with', data);
                        responseCallback(data);
                    }
                });
            }
            bridge.registerHandler(name, function (data, responseCallback) {
                callback(data, responseCallback)
            })
        })
    },

}
